<template>
  <div>
    <v-select
      label="text"
      :options="options"
      v-model="rowData.floorID"
      :reduce="text => text.value"
      :clearable="false"
      :searchable="false"
    >
      <template #no-options>
        {{$t('common.no_options')}}
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import common from "@/common";

export default {
  name: "SlotFloor",
  components: {
    vSelect
  },
  props: {
    rowData: {type: Object},
    facilityId: {type: Number}
  },
  data() {
    return {
      options: []
    }
  },
  watch: {
    facilityId: function (facilityID, oldFacilityID) {
      if (oldFacilityID) {
        this.rowData.floorID = null
        this.options = []
      }

      this.getFloorOptions(facilityID)
    }
  },
  mounted() {
    // if (common.getAdminFacilityId()) {
    //   this.getFloorOptions(common.getAdminFacilityId())
    // }
    this.getFloorOptions(this.facilityId)
  },
  methods: {
    getFloorOptions: function (facility_id) {
      common.getFloorOptions(facility_id).then(res => {
        this.options = res
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
